export default "/img/ME.6e14ac811b01cd55d2a093df3cfabb5f.png";